import { RelatedAssessmentSubmissionFragment } from "types/graphql-schema";

import useLabel from "@apps/use-label/use-label";
import Avatars from "@components/avatar/avatars";
import Button from "@components/button/button";
import { buttonTheme } from "@components/button/button-constants";
import Modal from "@components/modal/modal";
import ModalTitle from "@components/modal/modal-title";

import {
  filterManagerAndCompletedSubmissions,
  submissionLabels,
} from "./helpers";
import RelatedSubmissionStatusPill from "./related-submission-status-pill";

const DownwardReviewWarning = ({
  isOpen,
  submissions,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
  submissions: RelatedAssessmentSubmissionFragment[];
}) => {
  const label = useLabel();

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="flex flex-col p-6">
        <ModalTitle className="mb-3">{`Some ${label("review", {
          capitalize: true,
          pluralize: true,
        })} Aren't Complete`}</ModalTitle>
        <div className="mb-6">
          We often recommend Managers complete their {label("review")} after
          these {label("review", { pluralize: true })} (shown below) are
          complete. Did you want to start working on this {label("review")}{" "}
          anyway?
        </div>
        <div className="text-xs font-medium mb-4">{`${label("review", {
          capitalize: true,
        })} Submissions`}</div>
        <div className="border rounded-md mb-6 flex flex-col divide-y">
          {submissions?.filter(filterManagerAndCompletedSubmissions).map(
            (submission) =>
              submission && (
                <div
                  key={submission.type}
                  className="flex items-center justify-between py-3 px-4"
                >
                  <div className="w-36 text-gray-500">
                    {submissionLabels(label)[submission.type]}
                  </div>
                  <RelatedSubmissionStatusPill submission={submission} />
                  <Avatars
                    users={submission.users}
                    max={5}
                    size={6}
                    modalTitle="Responders"
                  />
                </div>
              ),
          )}
        </div>

        <div className="flex items-center justify-end gap-4">
          <Button url="/assessments" text="I'll Come Back Later" />
          <Button
            onClick={onClose}
            theme={buttonTheme.primary}
            text={`Continue to ${label("review", { capitalize: true })}`}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DownwardReviewWarning;
